import { useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation } from "@tanstack/react-query";
import axios from "axios";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Buildings, CheckCircle, CircleNotch } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReferPage() {
  const { code } = useParams();
  const [form, setForm] = useState({ name: "", email: "", business: "", phone: "" });
  const [done, setDone] = useState(null);
  const { data, error } = useQuery({ queryKey: ["refer", code], queryFn: () => axios.get(`${API}/refer/${code}`).then((r) => r.data), retry: false });
  const join = useMutation({
    mutationFn: () => axios.post(`${API}/refer/${code}`, form),
    onSuccess: ({ data }) => setDone(data.message),
  });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-xl border border-zinc-200 bg-white p-8 shadow-sm" data-testid="refer-page">
        <div className="flex items-center gap-2 mb-6"><img src="/artha-logo.png" alt="Artha" className="w-9 h-9 object-contain" /><span className="font-heading text-lg text-zinc-900">Artha Business Solutions</span></div>
        {error ? (
          <p data-testid="refer-invalid" className="text-sm text-zinc-500">This invite link is invalid or expired.</p>
        ) : done ? (
          <div className="text-center py-6" data-testid="refer-thanks">
            <CheckCircle size={40} weight="fill" className="text-emerald-500 mx-auto mb-3" />
            <p className="text-sm font-medium text-zinc-900">{done}</p>
          </div>
        ) : data ? (
          <>
            <h1 className="font-heading text-xl text-zinc-900 mb-2">{data.referrer_first_name} thinks you'd love working with us</h1>
            <p className="text-xs text-zinc-500 mb-6">{data.blurb}</p>
            <div className="space-y-2.5">
              <Input data-testid="refer-name" placeholder="Your name" value={form.name} onChange={set("name")} />
              <Input data-testid="refer-email" placeholder="Work email" value={form.email} onChange={set("email")} />
              <Input data-testid="refer-business" placeholder="Business name (optional)" value={form.business} onChange={set("business")} />
              <Input data-testid="refer-phone" placeholder="Phone (optional)" value={form.phone} onChange={set("phone")} />
              {join.isError && <p className="text-[11px] text-rose-600">{join.error?.response?.data?.detail || "Something went wrong — try again"}</p>}
              <Button data-testid="refer-submit" className="w-full" disabled={!form.name.trim() || !form.email.trim() || join.isPending} onClick={() => join.mutate()}>
                {join.isPending ? <CircleNotch size={14} className="animate-spin mr-1" /> : null} Request an intro call
              </Button>
              <p className="text-[10px] text-zinc-400 text-center">No spam — a partner reaches out within one business day.</p>
            </div>
          </>
        ) : <p className="text-sm text-zinc-400">Loading…</p>}
      </div>
    </div>
  );
}
